import * as Constants from '../../constants';

import { useEffect, useState } from 'react';

import { Button } from "react-bootstrap";

import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LicenseFormModal from '../../components/admin/licenses/LicenseFormModal.jsx';
import LicensesDashboardCards from '../../components/admin/licenses/LicensesDashboardCards.jsx';
import LicensesTable from '../../components/admin/licenses/LicensesTable.jsx';
import ConfirmationModal from '../../components/widget/ConfirmationModal.jsx';
import Loading from '../../components/widget/Loading.js';

function LicensesPage() {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [licenses, setLicenses] = useState([]);
    const [licenseTypes, setLicenseTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [selectedLicense, setSelectedLicense] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleEdit = (license) => {
        setSelectedLicense(license);
        setShowModal(true);
    }

    const handleDelete = (license) => {
        setSelectedLicense(license)
        setShowDeleteModal(true)
    }

    const handleDeleteConfirmation = (id) => {
        setShowDeleteModal(false)
        setIsLoading(true);

        const controller = new AbortController();
        const signal = controller.signal;
        const token = localStorage.getItem("token");

        fetch(Constants.LICENSES_DELETE, {
            method: 'DELETE',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id }),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setLicenses(prevLicenses => prevLicenses.filter(license => license.id !== id));
                } else {
                    console.error('Erro na API:', responseJson.message);
                }
                setSelectedLicense(null);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') return;

                console.error('Erro na requisição de remoção:', error.message || error);
                setIsLoading(false);
            });
    }

    const handleCreate = () => {
        setSelectedLicense(null);
        setShowModal(true)
    }

    const handleSave = (license) => {
        console.warn('aqiu')
        setIsLoading(true);

        let url = Constants.LICENSES_CREATE
        let method = 'POST'
        if (license.id) {
            url = Constants.LICENSES_UPDATE
            method = 'PUT'
        }
        const controller = new AbortController();
        const signal = controller.signal;

        const token = localStorage.getItem("token");

        fetch(url, {
            method: method,
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(license),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    const savedLicense = responseJson.data; // O usuário que veio do banco
                    console.warn(savedLicense);
                    if (license.id) {
                        // Se for EDIÇÃO: substitui o usuário antigo pelo novo no array
                        setLicenses(prev => prev.map(u => u.id === savedLicense.id ? savedLicense : u));
                    } else {
                        // Se for CRIAÇÃO: adiciona o novo usuário ao final (ou início) da lista
                        setLicenses(prev => [...prev, savedLicense]);
                    }

                    // Se preferir recarregar tudo do zero, chame sua função de fetch inicial:
                    // fetchAllLicenses(); 
                }
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                console.error('Erro na requisição:', error.message || error);
                setIsLoading(false);
            });
    };

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {

            try {

                setIsLoading(true);

                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                const [licensesRes, licenseTypesRes, statusTypesRes] = await Promise.all([
                    fetch(Constants.LICENSES_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.LICENSE_TYPES_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.LICENSE_STATUS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!licensesRes.ok) {
                    const err = await licensesRes.json();
                    throw err;
                }

                if (!licenseTypesRes.ok) {
                    const err = await licenseTypesRes.json();
                    throw err;
                }

                if (!statusTypesRes.ok) {
                    const err = await statusTypesRes.json();
                    throw err;
                }

                const licensesJson = await licensesRes.json();
                const licenseTypesJson = await licenseTypesRes.json();
                const statusTypesJson = await statusTypesRes.json();

                if (licensesJson.status === "success") {
                    setLicenses(licensesJson.data);
                }

                if (licenseTypesJson.status === "success") {
                    setLicenseTypes(licenseTypesJson.data);
                }

                if (statusTypesJson.status === "success") {
                    setStatusTypes(statusTypesJson.data);
                }
            } catch (error) {

                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <div className="d-flex justify-content-between mb-4">

                        <h3 style={{ color: '#fff' }}>Gerenciamento de Licenças</h3>

                        <Button onClick={handleCreate}>
                            <FontAwesomeIcon icon={faPlus} /> Nova Licença
                        </Button>

                    </div>
                    <LicensesDashboardCards licenses={licenses} />
                    <LicensesTable
                        licenses={licenses}
                        licenseTypes={licenseTypes}
                        statusTypes={statusTypes}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                    <LicenseFormModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} license={selectedLicense} />
                </>
            }
            {isLoading && <>
                <Loading />
            </>}

            {showDeleteModal && <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Licença"
                message={<p>Tem certeza que deseja excluir esta licença de <strong>{selectedLicense?.application}</strong> para o dispositivo <br /><strong>{selectedLicense?.device}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                id={selectedLicense.id}
            />
            }
        </div>
    </>
}

export default LicensesPage;